import { ErpClaimCode } from "../models/erp-claim-code.enum";

export const claimIsActive = (claims: string[] | null | undefined, claimCode: ErpClaimCode): boolean => {
    if (claims) {
        return claims.some(x => x === ErpClaimCode[claimCode]);
    }
    return false;
}